/**
 * Which columns an export leaves out, remembered per page on this computer
 * (FEAT-2026-029). Stored as the hidden column names, so a column a later
 * release adds is exported until someone unticks it.
 *
 * A convenience, not a record: storage that is blocked, cleared or unreadable
 * just means every column is exported.
 */
const PREFIX = "gk.export-columns.";

export function loadHiddenColumns(storageKey: string): string[] {
  try {
    const raw = window.localStorage.getItem(PREFIX + storageKey);
    const parsed: unknown = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed.filter((v): v is string => typeof v === "string") : [];
  } catch {
    return [];
  }
}

export function saveHiddenColumns(storageKey: string, hidden: string[]): void {
  try {
    if (hidden.length === 0) window.localStorage.removeItem(PREFIX + storageKey);
    else window.localStorage.setItem(PREFIX + storageKey, JSON.stringify(hidden));
  } catch {
    // Not remembered this time; the export still uses the choice on screen.
  }
}
